import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { MbTextField } from '../../../../components/MbTextFields';
import useAppInfo from '../../../../hooks/appInfo.hook';
import { appPublishStatus } from '../../../../utils/constants';

export default function AppleAccount({ errors, register }) {
  const { appInfo } = useAppInfo()
  const isRequired = appInfo.iOSPublishStatus !== appPublishStatus.FIRST_PUBLISH_PENDING;

  return (
    <Box mb={6}>
      <Typography variant="h5" mb={2}>
        Conta de desenvolvedor Apple
      </Typography>

      <Grid
        container
        component="form"
        spacing={2}
        direction={'row'}
      >
        <Grid item xs={12} sm={12}>
          <Grid item xs={12} sm={12}>
            <MbTextField
              error={errors.teamName?.message}
              label="Nome da entidade"
              register={register("teamName", {
                required: isRequired && "O nome da entidade da sua conta de desenvolvedor Apple é obrigatório."
              })}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <MbTextField
              error={errors.teamID?.message}
              label="ID da equipe"
              register={register("teamID", {
                required: isRequired && "O ID da equipe da sua conta de desenvolvedor Apple é obrigatório."
              })}
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}